import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import '../../components/Button/NeonButton.css';
import './CoreboundNavButton.css';

const CoreboundNavButton = forwardRef(
  ({ to, className = '', children, ...props }, ref) => {
    const Component = to ? Link : 'button';
    return (
      <Component
        ref={ref}
        {...(to ? { to } : { type: 'button' })}
        className={`coreboundBack neonButton coreboundNavButton ${className}`}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

export default CoreboundNavButton;
